module.exports = __webpack_public_path__ + "img/05be24d.jpg";